import { ScheduleBase } from './base/schedule-base';

export class Schedule extends ScheduleBase { }